export const controlAnnouncement = (container) => {
    const announcementTitle = container.dataset.announcementTitle;

    if (announcementTitle) {
        const currentTitle = localStorage.getItem("announcementTitle");
        console.log(currentTitle);
        console.log(announcementTitle);

        if (currentTitle === announcementTitle) {
            container.classList.add("close-announcement");
            const parentHeader = container.closest(".site-header");

            if (parentHeader) {
                parentHeader.classList.add("no-announcement");
            }
        } else {
            const closeButton = container.querySelector(".announcement__close");

            closeButton.addEventListener("click", (e) => {
                localStorage.setItem("announcementTitle", announcementTitle);
                container.classList.add("close-announcement");
                const parentHeader = container.closest(".site-header");

                if (parentHeader) {
                    parentHeader.classList.add("no-announcement");
                }
            })
        }
    }
}